var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.votes)?_c('div',[_c(_vm.get_design(),{tag:"component",attrs:{"survey":_vm.survey,"design":_vm.design,"votes":_vm.votes,"entries":_vm.entries}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }